import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, Key, LogOut, ShieldCheck } from "lucide-react";
import ChangePasswordDialog from "./ChangePasswordDialog";

function UserMenu({ user, onLogout, variant = "default" }) {
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const isAdmin = !!user && ((user.role_ids || []).includes("role-super-admin") || user.role === "ADMIN");

  const buttonClass =
    variant === "header"
      ? "bg-white/10 hover:bg-white/20 text-white border-white/30"
      : "";

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className={buttonClass}
            data-testid="user-menu-btn"
          >
            <User className="w-4 h-4 mr-2" />
            {user?.name || user?.email}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          {isAdmin && (
            <>
              <DropdownMenuItem
                onClick={() => navigate("/role-management")}
                data-testid="admin-menu-item"
              >
                <ShieldCheck className="w-4 h-4 mr-2" />
                Administration
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          )}
          <DropdownMenuItem
            onClick={() => setShowChangePassword(true)}
            data-testid="change-password-menu-item"
          >
            <Key className="w-4 h-4 mr-2" />
            Change Password
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={onLogout}
            data-testid="logout-menu-item"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangePasswordDialog
        open={showChangePassword}
        onOpenChange={setShowChangePassword}
      />
    </>
  );
}

export default UserMenu;
